import React, { useCallback, useEffect, useState } from 'react';
import { mask } from 'remask';
import {
  ArrowBack,
  CalendarTodayRounded,
  EditRounded,
  KeyRounded,
  LinkedIn,
  LockOpenRounded,
  MailOutlineRounded,
  PhoneRounded,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SwipeableDrawer,
} from '@mui/material';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';
import { stringAvatar } from '../../utils/avatarGenerator';

import { getUserByIdRequest, updateUserRequest, User } from '../../services';

import useAuthStore from '../../store/auth';
import useModalToCompleteProfile from '../../store/modalToCompleteProfile';

import { DrawerEditMember } from './components/DrawerEditMember';

import { EditPassword } from './components/drawerEditPassword';
import { NotificationsPermissions } from './components/notificationsPermissions';

import { Container, Div, Page, SectionUser, TextDialog, Title } from './styles';

export function DadosPessoais() {
  const user = useAuthStore(state => state.user);
  const setMenuSelected = useAuthStore(state => state.setMenuSelected);
  const openModalToCompleteProfile = useModalToCompleteProfile(
    state => state.openModalToCompleteProfile,
  );
  const setOpenModalToCompleteProfile = useModalToCompleteProfile(
    state => state.setOpenModalToCompleteProfile,
  );

  const navigate = useNavigate();

  const [openDrawerAddMember, setOpenDrawerAddMember] = useState(false);
  const [userToEdit, setUserToEdit] = useState({} as any);
  const [openDrawerEditPassword, setOpenDrawerEditPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalDesactiveUser, setOpenModalDesactiveUser] = useState(false);
  const [userSelected, setUserSelected] = useState<User>({ doc: '' } as User);

  const getUser = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getUserByIdRequest(user?.id as string);

      if (response?.status === 200) {
        setUserSelected(response.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    if (user?.id) {
      getUser();
    }
  }, [user]);

  const handleEditUser = useCallback((usr: any) => {
    setUserToEdit(usr);
    setOpenDrawerAddMember(true);
  }, []);

  const handleDesactiveUser = useCallback(async () => {
    try {
      if (user?.profile === 'UN1' || user?.profile === 'UN2') {
        const userDesactive = {
          status: 'US2',
        };

        const response = await updateUserRequest(
          user?.id as string,
          userDesactive as any,
        );

        if (response?.status === 200) {
          setUserSelected({ ...response?.data });
          setOpenModalDesactiveUser(false);
          toast.success('Usuário desativado com sucesso');
        }
      } else {
        toast.warning('Você não tem permissão para desativar usuários');
      }
    } catch (error) {
      console.log(error);
    }
  }, [user]);

  const handleNextProgressForCompleteProfile = () => {
    setOpenModalToCompleteProfile(false);
    setUserToEdit(userSelected);
    setOpenDrawerAddMember(true);
  };

  const handleGoBack = () => {
    setMenuSelected('portal');
    navigate('/home/reunioes');
  };

  const editProfile = () => (
    <DrawerEditMember setOpenDrawerAddMember={setOpenDrawerAddMember} />
  );

  const editPassword = () => (
    <EditPassword setOpenDrawer={setOpenDrawerEditPassword} />
  );

  return (
    <Container>
      {loading ? (
        <Box
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Page>
          {user?.companies_ids && user.companies_ids.length > 0 && (
            <Button
              onClick={handleGoBack}
              sx={{
                display: 'flex',
                gap: '10px',
                color: '#212121',
                borderColor: '#212121',
                width: '213px',
                height: '48px',
                fontWeight: '500',
                fontSize: '15px',
                whiteSpace: 'nowrap',
                marginBottom: '20px',
              }}
              variant="outlined"
            >
              <ArrowBack /> Voltar ao portal
            </Button>
          )}
          <SectionUser
            sx={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box display="flex" flexDirection="column" gap="10px">
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="20px"
                marginBottom="10px"
              >
                {userSelected?.avatar_url ? (
                  <Avatar
                    sx={{
                      width: '60px',
                      height: '60px',
                      fontSize: '24px',
                      bgcolor: '#12094d',
                    }}
                  >
                    <img
                      src={userSelected?.avatar_url as string}
                      alt="Foto de perfil"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center',
                      }}
                    />
                  </Avatar>
                ) : (
                  <Avatar
                    {...stringAvatar(userSelected?.name)}
                    sx={{
                      width: '60px',
                      height: '60px',
                      fontSize: '24px',
                      bgcolor: '#12094d',
                    }}
                  />
                )}
                <Box className="name-user">{userSelected?.name}</Box>
                {userSelected?.status === 'US1' && (
                  <Box className="active">Ativo</Box>
                )}

                {userSelected?.status === 'US2' && (
                  <Box className="desactive">Desativado</Box>
                )}
                {userSelected?.status === 'US3' && (
                  <Box className="pendent">Pendente</Box>
                )}
              </Div>
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="10px"
              >
                <CalendarTodayRounded sx={{ fontSize: '26px' }} />
                <Box className="text-details">
                  Cadastrado em:{' '}
                  {dayjs(userSelected?.created_at || new Date()).format(
                    'DD/MM/YYYY',
                  )}
                </Box>
              </Div>
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="10px"
              >
                <MailOutlineRounded sx={{ fontSize: '26px' }} />
                <Box className="text-details">
                  E-mail: {userSelected?.email}
                </Box>
              </Div>
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="10px"
              >
                <PhoneRounded sx={{ fontSize: '26px' }} />
                <Box className="text-details">
                  {userSelected?.phone === null
                    ? 'Número de celular não adicionado'
                    : `Celular: ${userSelected?.phone}`}
                </Box>
              </Div>
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="10px"
              >
                <KeyRounded sx={{ fontSize: '26px' }} />
                <Box className="text-details">
                  {userSelected?.doc === null
                    ? 'Documento não adicionado'
                    : `CPF: ${mask(userSelected?.doc, ['999.999.999-99'])}`}
                </Box>
              </Div>
              <Div
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="10px"
              >
                <LinkedIn sx={{ fontSize: '26px' }} />
                <Box className="text-details">
                  {userSelected?.linkedIn === null
                    ? 'Link do perfil não adicionado'
                    : userSelected?.linkedIn}
                </Box>
              </Div>
              {/* <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <SecurityRounded sx={{ fontSize: '26px' }} />
              <Box className="text-details">
                Permissão: {userSelected?.profile === 'UN1' && 'Master'}
                {userSelected?.profile === 'UN2' && 'Admin'}
                {userSelected?.profile === 'UN3' && 'Membro'}
                {userSelected?.profile === 'UN4' && 'Convidado'}
              </Box>
            </Div> */}
            </Box>
            <Box display="flex" flexDirection="column" gap="10px">
              {user?.profile === 'UN1' ||
              user?.profile === 'UN2' ||
              user?.profile === 'UN3' ? (
                <>
                  <React.Fragment key="right">
                    {userSelected?.status === 'US1' && (
                      <Button
                        variant="contained"
                        onClick={() => handleEditUser(userSelected)}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '6px 16px 6px 12px',
                          height: '40px',
                        }}
                        className="btn-users"
                      >
                        <EditRounded />
                        <Box className="text-details">Editar Dados</Box>
                      </Button>
                    )}
                    {userSelected?.status === 'US3' && (
                      <Button
                        variant="contained"
                        onClick={() => handleEditUser(userSelected)}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '6px 16px 6px 12px',
                          height: '40px',
                        }}
                        className="btn-users"
                      >
                        <EditRounded />
                        <Box className="text-details">Editar Dados</Box>
                      </Button>
                    )}
                  </React.Fragment>
                  <SwipeableDrawer
                    className="drawer"
                    anchor="right"
                    open={openDrawerAddMember}
                    onClose={() => setOpenDrawerAddMember(false)}
                    onOpen={() => setOpenDrawerAddMember(true)}
                    ModalProps={{
                      keepMounted: true,
                    }}
                  >
                    {editProfile()}
                  </SwipeableDrawer>
                </>
              ) : (
                ''
              )}
              {user?.profile === 'UN1' ||
              user?.profile === 'UN2' ||
              user?.profile === 'UN3' ? (
                <>
                  <Button
                    variant={
                      userSelected?.status === 'US2' ? 'contained' : 'outlined'
                    }
                    onClick={() => setOpenDrawerEditPassword(true)}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'start',
                      justifyContent: 'start',
                      width: '100%',
                    }}
                    className="btn-users"
                  >
                    {userSelected?.status === 'US2' ? (
                      <Box className="text-details">Usuário desativado</Box>
                    ) : (
                      <Box
                        className="text-details"
                        display="flex"
                        alignItems="center"
                        gap="10px"
                      >
                        <LockOpenRounded sx={{ color: '#206da7' }} />
                        Alterar senha
                      </Box>
                    )}
                  </Button>
                  <SwipeableDrawer
                    onClose={() => setOpenDrawerEditPassword(false)}
                    onOpen={() => setOpenDrawerEditPassword(true)}
                    anchor="right"
                    open={openDrawerEditPassword}
                  >
                    {editPassword()}
                  </SwipeableDrawer>
                </>
              ) : (
                ''
              )}

              <Dialog
                open={openModalDesactiveUser}
                onClose={() => setOpenModalDesactiveUser(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="dialog-main"
              >
                <DialogTitle id="alert-dialog-title">
                  Desativar Usuário
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Ao remover, o usuário não terá mais acesso a nenhuma
                    informação desta empresa. Deseja prosseguir?
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: '20px' }}>
                  <Button
                    onClick={() => setOpenModalDesactiveUser(false)}
                    variant="text"
                    sx={{ color: '#9E9E9E' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={handleDesactiveUser}
                    autoFocus
                    color="error"
                    variant="contained"
                  >
                    Confirmar
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={openModalToCompleteProfile}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="dialog-main"
              >
                <DialogTitle
                  id="alert-dialog-title"
                  color="success"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'start',
                    width: '100%',
                  }}
                >
                  <TextDialog>Olá, {user?.name}!</TextDialog>
                </DialogTitle>
                <DialogContent sx={{ padding: '5px 24px' }}>
                  <DialogContentText
                    id="alert-dialog-description"
                    sx={{ color: 'rgb(0 0 0)' }}
                  >
                    Estamos animados para tê-lo(a) em nosso sistema. Para
                    começar, precisamos que você complete seu cadastro. Vamos
                    lá!
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: '20px' }}>
                  <Button
                    onClick={handleNextProgressForCompleteProfile}
                    autoFocus
                    color="success"
                    variant="contained"
                    sx={{ color: '#fff' }}
                  >
                    Prosseguir
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </SectionUser>
          <SectionUser marginTop="20px">
            <Title>Preferências</Title>
            <NotificationsPermissions />
          </SectionUser>
        </Page>
      )}
    </Container>
  );
}
